import { pipe } from 'fp-ts/function';
import { withFeatureFlagService } from '@mews/framework';
import { CheckoutView as BaseCheckoutView } from './CheckoutView';
import { inject } from './inject';

export const CheckoutView = pipe(BaseCheckoutView, inject, withFeatureFlagService);
